import { Fragment } from 'react';
import { CUR_NETWORK, FAQ_DOMAIN } from "@constants/index";
import { IFaq, ISetFaq, l10nType } from "@type/index";

/**
 * 도움말
*/
export const setFaqItem = (item: IFaq): ISetFaq | null => {
    return item && typeof item === 'object' ? {
        ...item,
        url: `${FAQ_DOMAIN[CUR_NETWORK]}/faq/search?faqNo=${item?.id}`
    } : null;
};

export const FaqArticle = ({ item, l10n }: {item: IFaq, l10n: l10nType}) => {
    const data = setFaqItem(item);

    if(!data) {
        return <Fragment />;
    }

    const { url, subject, content, categoryName } = data;
    return <div className="search-item-content">
        <a href={ url }>
            <div className="search-item-title" dangerouslySetInnerHTML={{__html: subject}}></div>
            <div className="search-item-summary" dangerouslySetInnerHTML={{__html: content}}></div>
        </a>
        <div className="search-item-info">
            <span className="category">{ categoryName }</span>
        </div>
    </div>;
};